import React, {useState, useEffect} from 'react';

function ClientViewPageMain() {
    const [serverStatus, setServerStatus] = useState(false);
    const [gameStatus, setGameStatus] = useState(true);
    const [udpStreamStatus, setUdpStreamStatus] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (window.pywebview && window.pywebview.api) {
                const server_status = await window.pywebview.api.get_server_connection_status();
                setServerStatus(server_status);

                const game_status = await window.pywebview.api.get_game_running_status();
                setGameStatus(game_status);

                const udp_stream_status = await window.pywebview.api.get_udp_stream_status();
                setUdpStreamStatus(udp_stream_status);
            }
        };

        const interval = setInterval(fetchData, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <main className="flex-1 p-6 flex flex-col gap-6 carbon-pattern justify-center items-center">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto w-full">
                <div className="bg-white/5 dark:bg-[#192633] border border-slate-300 dark:border-[#324d67] rounded-xl p-6 flex flex-col items-center justify-center gap-4 text-center group transition-all hover:bg-white/10 dark:hover:bg-[#1e2e3d] hover:border-emerald-500/50">
                    <div className={`${gameStatus ? "bg-emerald-500 shadow-[0_0_15px_rgba(16,185,129,0.8)]" : "bg-acc-red"} size-4 rounded-full`}></div>
                
                    <div>
                        <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Game Connection</p>
                        <p className={`${gameStatus ? "text-emerald-500" : "text-acc-red"} text-lg font-bold`}>{gameStatus ? "ACTIVE" : "INACTIVE"}</p>
                    </div>
                </div>

                <div className="bg-white/5 dark:bg-[#192633] border border-slate-300 dark:border-[#324d67] rounded-xl p-6 flex flex-col items-center justify-center gap-4 text-center group transition-all hover:bg-white/10 dark:hover:bg-[#1e2e3d] hover:border-emerald-500/50">
                    <div className={`${serverStatus ? "bg-emerald-500 shadow-[0_0_15px_rgba(16,185,129,0.8)]" : "bg-acc-red"} size-4 rounded-full`}></div>
                    
                    <div>
                        <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Server Connection</p>
                        <p className={`${serverStatus ? "text-emerald-500" : "text-acc-red"} text-lg font-bold`}>{serverStatus ? "STABLE" : "OFFLINE"}</p>
                    </div>
                </div>

                <div className="bg-white/5 dark:bg-[#192633] border border-slate-300 dark:border-[#324d67] rounded-xl p-6 flex flex-col items-center justify-center gap-4 text-center group transition-all hover:bg-white/10 dark:hover:bg-[#1e2e3d] hover:border-primary/50">
                    <div className="size-4 rounded-full bg-primary pulse-blue"></div>
                    
                    <div>
                        <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Sync Status</p>
                        <p className="text-lg font-bold text-primary">{udpStreamStatus ? "SYNCHRONIZING" : "NOT SENDING"}</p>
                    </div>
                </div>
            </div>
        </main>
    );
}


export default ClientViewPageMain;